import React from 'react';
import { Text } from "@fluentui/react-components";
import { MailInboxRegular } from "@fluentui/react-icons";
import { Incident } from "#root/queries/incidents";
import LoadingWrapper from "#root/components/LoadingWrapper";
import Paginator from "#root/components/Paginator";
import './styles.scss';

export interface IncidentListProps {
  title: string;
  incidents: Incident[];
  isLoading: boolean;
  page: number;
  onPageChange: (newPage: number) => void;
  totalItems: number;
  itemsPerPage: number;
  renderActions: (incident: Incident) => React.ReactNode;
  headerActions?: React.ReactNode;
}

const IncidentList: React.FC<IncidentListProps> = ({
  title,
  incidents,
  isLoading,
  page,
  onPageChange,
  totalItems,
  itemsPerPage,
  renderActions,
  headerActions
}) => (
  <section className="incidents-section">
    <h2>
      {title} <div className="divider" />
      {headerActions}
    </h2>
    <div className="list-cards">
      <LoadingWrapper
        isLoading={isLoading}
        isEmpty={incidents.length === 0}
        emptyMessage={`No ${title.toLowerCase()} found`}
        emptyIcon={<MailInboxRegular />}
      >
        {incidents.map((incident) => (
          <div key={incident.id} className="list-card">
            <div className="incident-info">
              <Text weight="semibold">{incident.name}: </Text>
              <Text>{incident.address}</Text>
            </div>
            <div className="flex-spacer" />
            <div className="list-card__actions">
              {renderActions(incident)}
            </div>
          </div>
        ))}
        <Paginator
          currentPage={page + 1}
          totalPages={Math.ceil(totalItems / itemsPerPage)}
          onPageChange={(newPage) => onPageChange(newPage - 1)}
        />
      </LoadingWrapper>
    </div>
  </section>
);

export default IncidentList;
